import { createSectionSmart, generatePage, getFirstLayers } from "./index";
import { getColorByVariantPaperColor, getColorByVariantRibbonColor, isMultiColored as isMaterialMultiColored } from "../material";
export var generateSimpleProject = function (innerMaterial, materialSelectedArticleNumber) {
    var _a;
    var colorSchema = innerMaterial.variants.find(function (variant) { return variant.article_number === materialSelectedArticleNumber; }) || innerMaterial.variants[0];
    var ribbonColor = getColorByVariantPaperColor(colorSchema);
    var paperColor = getColorByVariantRibbonColor(colorSchema);
    // build first page
    var page = generatePage({ material: innerMaterial });
    var pages = (_a = {}, _a[page.uid] = page, _a);
    // add first section
    var section;
    var shield = getFirstLayers(pages).shield;
    if (shield) {
        var isMultiColored = isMaterialMultiColored(innerMaterial.printParameters);
        section = createSectionSmart({ sourceShield: shield, pages: pages, ribbonColor: (!isMultiColored && ribbonColor) || null, paperColor: null });
        if (section) {
            page.sections[section.id] = section.toDict();
        }
    }
    return { pages: pages, colorSchema: colorSchema, pagesOrder: Object.keys(pages) };
};
